__turbopack_context__.v({
  "core-image": "CoreImage-module-scss-module__-2kutq__core-image",
});
